// Petit helper Google Analytics (GA4) pour l'audioguide.
// N'envoie rien si gtag n'est pas chargé (ID non configuré, bloqueur, etc.).
export function track(event, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', event, params);
  }
}
